/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var TengeIcon = createIcon({
  name: 'TengeIcon',
  height: 512,
  width: 384,
  svgPath: 'M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default TengeIcon;